// extracted by mini-css-extract-plugin
module.exports = {"projects-screen":"ProjectsScreen_projects-screen__3XlOo","grid":"ProjectsScreen_grid__27G6d","add-btn":"ProjectsScreen_add-btn__uy9BE"};